import { useEffect, useState, useCallback } from 'react';
import { dealerPlans } from '../services/plansApi';

/**
 * Resolves the logged-in dealer's plan + feature flags from /api/dealers/me/plan.
 * Cached in localStorage for instant first paint, then refreshed in background.
 */
export const usePlan = () => {
  const [plan, setPlan] = useState(() => {
    try {
      const cached = localStorage.getItem('dealer_plan_cache');
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(!plan);

  const refresh = useCallback(async () => {
    try {
      const r = await dealerPlans.me();
      setPlan(r);
      localStorage.setItem('dealer_plan_cache', JSON.stringify(r));
    } catch (e) {
      // keep cached value if request fails
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const hasFeature = (flag) => Boolean(plan?.features?.[flag]);

  return { plan, loading, hasFeature, refresh };
};
